let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("Wowvf"), load("jYr96")]).then(() => parcelRequire('1cgZV'));